import React from "react";
import "./LabeledValue.css";

const LabeledValue = ({ label, value, className = "", isBold = true }) => {
  if (!value && value !== 0) return "";
  const getValue = () => {
    if (typeof value === "string") {
      return value.split("\n").map(paragraph => (
        <span key={paragraph.slice(0, 7)} className="block-level-element">
          {paragraph}
        </span>
      ));
    }
    return value;
  };
  return (
    <div className={`labeled-value ${className}`}>
      <label>{isBold ? <b>{label}</b> : <>{label}</>}</label>
      <p>
        <b>{getValue()}</b>
      </p>
    </div>
  );
};

export default LabeledValue;
